class Friend {
    constructor({ id, firstname, lastname, email, invitationDirection, status, portfolioSharingDetails }) {
        this._id = id
        this._firstname = firstname
        this._lastname = lastname
        this._email = email
        this._invitationDirection = invitationDirection
        this._status = status
        this._portfolioSharingDetails = portfolioSharingDetails
    }

    get id() { return this._id }
    get firstname() { return this._firstname }
    get lastname() { return this._lastname }
    get email() { return this._email }
    get invitationDirection() { return this._invitationDirection }
    get status() { return this._status }
    get portfolioSharingDetails() { return this._portfolioSharingDetails }

    set id(value) { this._id = value }
    set firstname(value) { this._firstname = value }
    set lastname(value) { this._lastname = value }
    set email(value) { this._email = value }
    set status(value) { this._status = value }
    set portfolioSharingDetails(value) { this._portfolioSharingDetails = value }

    get fullName() {
        return `${this._firstname} ${this._lastname}`;
    }

    toJSON() {
        return {
            id: this._id,
            firstname: this._firstname,
            lastname: this._lastname,
            email: this._email,
            invitationDirection: this._invitationDirection,
            status: this._status,
            portfolioSharingDetails: this._portfolioSharingDetails
        };
    }
}

export default Friend;